// Configuration module that works in both dev and production
export default class Configuration {
    static get EnvConfig() {
        return {
            rootApi: '$VUE_APP_ROOT_API',
        }
    }

    static value(key) {
        // If the key does not exist in the EnvConfig object of the class, return null
        if (!Object.prototype.hasOwnProperty.call(this.EnvConfig, key)) {
            console.error(`Configuration: There is no key named "${key}". Please add it in Configuration class.`);
            return null;
        }

        // Get the value from EnvConfig
        const value = this.EnvConfig[key];

        // If the value is null or undefined, return null
        if (!value) {
            console.error(`Configuration: Value for "${key}" is not defined`);
            return null;
        }

        // Check if value starts with $VUE_APP_ (placeholder)
        if (value.startsWith('$VUE_APP_')) {
            // Value was not replaced, try multiple sources:
            const envName = value.substr(1); // Remove $ prefix

            // 1. Try runtime config (injected by entrypoint.sh)
            if (window._env_ && window._env_[envName]) {
                console.log(`Configuration: Using runtime config for "${key}" = "${window._env_[envName]}"`);
                return window._env_[envName];
            }

            // 2. Try build-time environment variable
            const envValue = process.env[envName];
            if (envValue) {
                return envValue;
            }

            // 3. Nothing found
            console.error(`Configuration: Environment variable "${envName}" is not defined in runtime config or build-time env`);
            console.error('Available runtime config:', window._env_);
            console.error('Available build-time env:', process.env);
            return null;
        }

        // Value was already replaced by envsubst in production
        return value;
    }
}